export default [
    {
        path: '/',
        name: 'Home',
        meta: { title: '舆情资讯', keepAlive: true, saveSrollTop: true },
        component: () => import('../views/home/index.vue')
    },
    {
        path: '/plate',
        name: 'Plate',
        meta: { title: '舆情资讯', keepAlive: true, saveSrollTop: true },
        component: () => import('../views/list/index.vue'),
    },
    {
        path: '/details',
        name: 'Details',
        meta: { title: '舆情资讯' },
        component: () => import('../views/details/index.vue')
    },
    {
        path: '/search',
        name: 'Search',
        meta: { title: '搜索结果' },
        component: () => import('../views/search-result/index.vue')
    },
    {
        path: '/me',
        name: 'Me',
        meta: { title: '个人主页' },
        component: () => import('../views/me/index.vue')
    },
    {
        path: '/recipient',
        name: 'Recipient',
        meta: { title: '收件人' },
        component: () => import('../views/recipient/index.vue')
    },
    {
        path: '/collection',
        name: 'Collection',
        meta: { title: '收藏夹' },
        component: () => import('../views/collection/index.vue')
    },
    {
        path: '/suggest',
        name: 'Suggest',
        meta: { title: '应急处理建议' },
        component: () => import('../views/suggest/index.vue')
    },
    {
        path: '/password/username',
        name: 'PasswordUsername',
        meta: { title: '忘记密码' },
        component: () => import('../views/passport/password/index.vue'),
    },
    {
        path: '/reg',
        name: 'Reg',
        meta: { title: '注册' },
        component: () => import('../views/passport/reg/index.vue'),
    },
    {
        path: '/login',
        name: 'Login',
        meta: { title: '登录' },
        component: () => import('../views/passport/login/index.vue'),
    },
    {
        path: '/:pathMatch(.*)',// 匹配所有路由
        redirect: '/'
    }
]